import { Injectable } from '@angular/core';
import { Kunde } from '@features/kunder/kunde.model';
import { KundeSearchParams } from '@features/kunder/kunde-search/kunde-search-params.model';
import { TableDatasource } from '@core/api/table.datasource';

@Injectable({
  providedIn: 'root',
})
export class KundeDatasource extends TableDatasource<Kunde, KundeSearchParams> {
  endpoint = '/api/admin/kunder';
  defaultSortField = 'fornavn';
}
